export const locales = {
    en: [
        { code: "en_GB", name: "English (UK)", shortName: "English" },
        { code: "en_US", name: "English (US)", shortName: "English" },
    ],
    es: [
        { code: "es_ES", name: "Español (España)", shortName: "Español" },
        { code: "es_MX", name: "Español (México)", shortName: "Español" },
    ],
};

export type Language = {
    code: string;
    name: string;
    shortName?: string;
};

export const getLocales = (languages: Language[]) => {
    let derivedLocales: Language[] = [];
    for (const language of languages) {
        const extendableLocales = locales[language.code as keyof typeof locales];
        if (extendableLocales) {
            derivedLocales = [...derivedLocales, ...extendableLocales];
        } else {
            derivedLocales.push(language);
        }
    }

    return derivedLocales;
};

export const getShortCode = (locale: string) => {
    /** If `locale` is provided as es_ES format, we'll convert it to es-ES, before splitting by separator "-" */
    const localeCode = locale.replace("_", "-");
    return localeCode.includes("-") ? localeCode.split("-")[0] : localeCode;
};

export interface LocalizationProps {
    localize?: boolean;
}
